// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"CategoryIcon_ProseMirror__2lz83","icon":"CategoryIcon_icon__2v-98","icon__toggle":"CategoryIcon_icon__toggle__1Xsj-"};